module.exports = {
  NOTIFICATIONS_WS_SERVER_HOST: process.env.NOTIFICATIONS_WS_SERVER_HOST || 'localhost',
  NOTIFICATIONS_WS_SERVER_PORT: process.env.NOTIFICATIONS_WS_SERVER_PORT || 4000,
  APP_ENVIRONMENT: process.env.APP_ENVIRONMENT || 'local',
  CDN_URL: process.env.CDN_URL || 'https://cdn.polystack.dev'
}
